import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {TooltipModule} from '../../components/tooltip';
import {TextHidingModule} from '../text-hiding';
import {DecimalInputWrapperComponent} from './decimal-input-wrapper';
import {DecimalInputDirective} from './decimal-input.directive';

@NgModule({
    imports: [
        CommonModule,
        TooltipModule,
        TextHidingModule
    ],
    declarations: [
        DecimalInputDirective,
        DecimalInputWrapperComponent
    ],
    exports: [
        DecimalInputDirective,
        DecimalInputWrapperComponent
    ]
})
export class DecimalInputModule {}
